<template>
  <div class="filterable-list__list-item-dates">
    <template v-for="(onedateDetail, index) in item.dateDetails" :key="index + '_date'">
      <div
        :key="index + '_abbr'"
        v-if="index == item.dateDetails.length - 1 && index !== 0"
        class="filterable-list__list-item-date is-connector"
      >
        <abbr
          v-set-attr="{ 'aria-label': item.date_till, 'title': item.date_till }"
          class="filterable-list__list-item-date-connect"
        >&mdash;</abbr>
      </div>
      <div class="filterable-list__list-item-date">
        <span
          :aria-label="onedateDetail.dateDay"
          class="filterable-list__list-item-date-day"
        >{{onedateDetail.dateDay}}</span>
        <abbr
          :aria-label="onedateDetail.dateMonthFull"
          :title="onedateDetail.dateMonthFull"
          class="filterable-list__list-item-date-month"
        >{{onedateDetail.dateMonthAbbr}}</abbr>
      </div>
    </template>
  </div>
</template>


<script>
import setAttrDirecitve from "./directives/set-attr.directive";
export default {
	name: 'EventCard',
	props: ['item'],
	directives: {
		setAttr: setAttrDirecitve
	},
};
</script>
